export const ComplianceConst = {
  Flows: 'flows',
  FlowValidate: 'flows-validate',
  Documents: 'documents',
  Fleet: 'fleet'
};

export const TemplateConst = {
  displayedColumns: [
    'name',
    'description',
    'module',
    'feature',
    'form',
    'action',
  ],
};

export const TemplateDetailConst = {
  displayedColumns: [
    'order',
    'question',
    'action',
  ],
};

export const DocumentConst = {
  displayedColumns: [
    'flow_id',
    'flow_name',
    'step_name',
    'name',
    'container_no',
    'expected_date',
    'actual_date',
    'status_name',
    'action',
  ],
};

export const FlowConst = {
  displayedColumns: [
    'id',
    'name',
    'pol_code',
    'pod_code',
    'personas',
    // 'groups',
    'steps',
    'status_name',
    'action',
  ],
  allowAddFlow: [3, 6, 13] // Logistics Service Provider, Shipper, Freight Forwarder
};

export const FlowValidationConst = {
  displayedColumns: [
    'id',
    'company',
    'name',
    'pol_code',
    'pod_code',
    'steps',
    'actual_date',
    'status_name',
    'action',
  ],
};

export const FleetConst = {
  displayedColumns: [
    'flow_id',
    'customer_name',
    'vehicle_no',
    'driver_name',
    'expected_date',
    'address',
    'action',
  ]
};
